import { FC } from 'react';
import { ErrorMolecule } from '../../molecules';

interface NotAuthorizedPageProps {}

const NotAuthorizedPage: FC<NotAuthorizedPageProps> = () => {
  return <ErrorMolecule content={'User is not authorized!'} />;
};

export default NotAuthorizedPage;
